import { Helmet } from 'react-helmet-async'

import { useEffect, useContext } from 'react'
import { Box } from '@mui/material'
// api
import api from 'src/api/solid/fetch'

// Context & Providers
import { FightDispatchContext } from 'src/store/fights/Store'
import { setFights } from 'src/store/fights/actions'

import { EventDispatchContext } from 'src/store/events/Store'
import { setEvents } from 'src/store/events/actions'

import { NPCDispatchContext } from 'src/store/npcs/Store'
import { setNPCs } from 'src/store/npcs/actions'

import { ItemDispatchContext } from 'src/store/items/Store'
import { setItems } from 'src/store/items/actions'

import { LocationDispatchContext } from 'src/store/locations/Store'
import { setLocations } from 'src/store/locations/actions'

// game UI
import Game from 'src/components/Game'
import { type Event, type Fight, type Item, type NPC, type Location } from 'src/types'
import { MapDispatchContext } from 'src/store/map/Store'
import { setAPIDataLoaded } from 'src/store/map/actions'


// ----------------------------------------------------------------------
const containerStyle = {
  width: '100vw',
  height: '100vh',
  position: 'relative'
}

const Home = () => {
  const { dispatchFights } = useContext(FightDispatchContext)
  const { dispatchEvents } = useContext(EventDispatchContext)
  const { dispatchNPCs } = useContext(NPCDispatchContext)
  const { dispatchItems } = useContext(ItemDispatchContext)
  const { dispatchLocations } = useContext(LocationDispatchContext)

  const { dispatchMap } = useContext(MapDispatchContext)

  // injects latest dependencies from db into the context
  useEffect(() => {
    let isMounted = true
    
    const getAndSetLiveContent = async () => {
      if (!isMounted) return
      
      console.log('🚀 Starting to load game data...')
      
      try {
        console.log('📥 Loading fights...')
        const fights: Fight[] = await api.list('fights')
        if (!isMounted) return
        const newFights: Record<string, Fight> = {}
        fights.forEach(fight => {
          newFights[fight.id] = fight
        })
        setFights(dispatchFights, newFights)
        console.log(`✅ Loaded ${fights.length} fights`)

        console.log('📥 Loading events...')
        const events: Event[] = await api.list('quests')
        if (!isMounted) return
        const newEvents: Record<string, Event> = {}
        events.forEach(event => {
          newEvents[event.id] = event
        })
        setEvents(dispatchEvents, newEvents)
        console.log(`✅ Loaded ${events.length} events`)

        console.log('📥 Loading NPCs...')
        const NPCs: NPC[] = await api.list('npcs')
        if (!isMounted) return
        const newNPCs: Record<string, NPC> = {}
        NPCs.forEach(NPC => {
          newNPCs[NPC.id] = NPC
        })
        setNPCs(dispatchNPCs, newNPCs)
        console.log(`✅ Loaded ${NPCs.length} NPCs`)

        console.log('📥 Loading items...')
        const items: Item[] = await api.list('items')
        if (!isMounted) return
        const newItems: Record<string, Item> = {}
        items.forEach(item => {
          newItems[item.id] = item
        })
        setItems(dispatchItems, newItems)
        console.log(`✅ Loaded ${items.length} items`)

        console.log('📥 Loading locations...')
        const locations: Location[] = await api.list('locations')
        if (!isMounted) return
        const newLocations: Record<string, Location> = {}
        // add the PFGrid on this step ?
        locations.forEach(location => {
          newLocations[location.id] = location
        })
        setLocations(dispatchLocations, newLocations)
        setAPIDataLoaded(dispatchMap, true)
        console.log(`✅ Loaded ${locations.length} locations`)
        console.log('🎉 All game data loaded successfully!')
      } catch (error) {
        console.error('❌ Error loading game data:', error)
      }
    }

    getAndSetLiveContent()
    
    return () => {
      isMounted = false
    }
  }, [dispatchFights, dispatchEvents, dispatchNPCs, dispatchItems, dispatchLocations, dispatchMap])

  return (
    <>
      <Helmet>
        <title>Samsara</title>
        <meta name='description' content='The Web version of the game samsara by storycoding' />
      </Helmet>
        <Box sx={containerStyle} className="home">
          <Game />
        </Box>
    </>
  )
}

export default Home
